const nav = document.querySelector('.nav');
const hamburger = document.querySelector('.hamburger');
if (hamburger && nav) {
  hamburger.addEventListener('click', () => nav.classList.toggle('open'));
}

const toast = document.querySelector('[data-toast]');
function showToast(message){
  if(!toast) return;
  toast.textContent = message;
  toast.classList.add('show');
  clearTimeout(showToast._timer);
  showToast._timer = setTimeout(()=>toast.classList.remove('show'), 1700);
}

let cartState = { item_count: Number(document.querySelector('[data-cart-count], .cart-count')?.textContent || 0), variantQty: new Map(), serverVariantQty: new Map() };
const pendingVariantTimers = new Map();
const pendingAddPromises = new Map();

async function fetchCart(){
  const res = await fetch('/cart.js', {headers:{'Accept':'application/json'}});
  if(!res.ok) throw new Error('Unable to load cart');
  return res.json();
}

function hydrateCartState(cart){
  cartState.item_count = cart?.item_count || 0;
  cartState.variantQty = new Map();
  cartState.serverVariantQty = new Map();
  (cart?.items || []).forEach(item => {
    const key = String(item.variant_id);
    const qty = Number(item.quantity || 0);
    cartState.variantQty.set(key, (cartState.variantQty.get(key) || 0) + qty);
    cartState.serverVariantQty.set(key, (cartState.serverVariantQty.get(key) || 0) + qty);
  });
}

function updateCartUI(input){
  const count = typeof input === 'number' ? input : (input?.item_count || 0);
  document.querySelectorAll('[data-cart-count], .cart-count').forEach(el => el.textContent = count);
  document.querySelectorAll('[data-floating-count]').forEach(el => el.textContent = count);
  const floating = document.querySelector('[data-floating-cart]');
  if(floating){ floating.classList.toggle('show', count > 0); }
}

function updateAllCardsForVariant(variantId, qty){
  document.querySelectorAll(`[data-variant-chip][data-variant-id="${variantId}"]`).forEach(chip => {
    chip.dataset.quantity = String(Math.max(0, Number(qty || 0)));
    const card = chip.closest('[data-product-card]');
    if(card && typeof card._mewaramUpdateCard === 'function') card._mewaramUpdateCard();
  });
}

function optimisticSetVariantQty(variantId, nextQty){
  const id = String(variantId);
  const current = cartState.variantQty.get(id) ?? Number(document.querySelector(`[data-variant-chip][data-variant-id="${id}"]`)?.dataset.quantity || 0);
  nextQty = Math.max(0, Number(nextQty || 0));
  cartState.variantQty.set(id, nextQty);
  cartState.item_count = Math.max(0, (cartState.item_count || 0) + (nextQty - current));
  updateCartUI(cartState.item_count);
  updateAllCardsForVariant(id, nextQty);
}

async function addVariantServer(variantId, quantity){
  const res = await fetch('/cart/add.js', {
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body: JSON.stringify({items:[{id:Number(variantId), quantity:Number(quantity)}]})
  });
  if(!res.ok) throw new Error('Add to cart failed');
  return res.json();
}

async function changeVariantQuantityServer(variantId, quantity){
  const res = await fetch('/cart/change.js', {
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body: JSON.stringify({id:String(variantId), quantity:Math.max(0, Number(quantity))})
  });
  if(!res.ok) throw new Error('Cart update failed');
  return res.json();
}

function syncCartSoon(delay = 260){
  clearTimeout(syncCartSoon._timer);
  syncCartSoon._timer = setTimeout(async () => {
    try{
      const cart = await fetchCart();
      hydrateCartState(cart);
      updateCartUI(cart);
      document.querySelectorAll('[data-product-card]').forEach(card => {
        card.querySelectorAll('[data-variant-chip]').forEach(chip => {
          const qty = cartState.variantQty.get(String(chip.dataset.variantId)) || 0;
          chip.dataset.quantity = String(qty);
        });
        if(typeof card._mewaramUpdateCard === 'function') card._mewaramUpdateCard();
      });
    }catch(e){}
  }, delay);
}

function queueServerVariantQty(variantId, nextQty){
  const id = String(variantId);
  nextQty = Math.max(0, Number(nextQty || 0));
  clearTimeout(pendingVariantTimers.get(id));
  pendingVariantTimers.set(id, setTimeout(async () => {
    const targetQty = cartState.variantQty.get(id) || 0;
    const serverQty = cartState.serverVariantQty.get(id) ?? 0;
    try{
      if(serverQty === 0 && targetQty > 0){
        const addPromise = addVariantServer(id, targetQty);
        pendingAddPromises.set(id, addPromise);
        await addPromise;
        pendingAddPromises.delete(id);
      } else {
        const inFlightAdd = pendingAddPromises.get(id);
        if(inFlightAdd) await inFlightAdd;
        await changeVariantQuantityServer(id, targetQty);
      }
      cartState.serverVariantQty.set(id, targetQty);
      syncCartSoon(120);
    }catch(e){
      showToast('Cart sync issue. Refreshing cart.');
      syncCartSoon(0);
    }
  }, 140));
}

function setVariantQtyFast(variantId, nextQty){
  optimisticSetVariantQty(variantId, nextQty);
  queueServerVariantQty(variantId, nextQty);
}

function initProductCard(card){
  const chips = [...card.querySelectorAll('[data-variant-chip]')];
  const addBtn = card.querySelector('[data-card-add]');
  const stepper = card.querySelector('[data-card-stepper]');
  const qtyEl = card.querySelector('[data-card-qty]');
  const priceEl = card.querySelector('[data-card-price]');
  const compareEl = card.querySelector('[data-card-compare]');
  const saleBadge = card.querySelector('[data-card-sale-badge]');
  let currentChip = chips.find(chip => chip.classList.contains('active')) || chips[0];

  chips.forEach(chip => {
    const id = String(chip.dataset.variantId);
    const qty = Number(chip.dataset.quantity || 0);
    if(!cartState.variantQty.has(id)) cartState.variantQty.set(id, qty);
    if(!cartState.serverVariantQty.has(id)) cartState.serverVariantQty.set(id, qty);
  });

  function selectedVariantId(){ return currentChip?.dataset.variantId; }
  function selectedQty(){ return Number(currentChip?.dataset.quantity || cartState.variantQty.get(String(selectedVariantId())) || 0); }

  function updateState(){
    if(!currentChip) return;
    const qty = selectedQty();
    const available = currentChip.dataset.available !== 'false';
    if(priceEl) priceEl.textContent = currentChip.dataset.price || '';
    if(compareEl){
      const compare = currentChip.dataset.compare || '';
      const price = currentChip.dataset.price || '';
      if(compare && compare !== price && compare !== '₹0.00' && compare !== 'Rs. 0.00'){ compareEl.textContent = compare; compareEl.hidden = false; }
      else { compareEl.hidden = true; }
    }
    if(saleBadge){
      const discount = Number(currentChip.dataset.discount || 0);
      if(discount > 0){ saleBadge.textContent = `${discount}% OFF`; saleBadge.hidden = false; }
      else { saleBadge.hidden = true; }
    }
    if(qty > 0){
      if(addBtn) addBtn.hidden = true;
      if(stepper) stepper.hidden = false;
      if(qtyEl) qtyEl.textContent = qty;
    } else {
      if(addBtn){ addBtn.hidden = false; addBtn.disabled = !available; addBtn.textContent = available ? 'Add to Cart' : 'Sold Out'; }
      if(stepper) stepper.hidden = true;
    }
  }
  card._mewaramUpdateCard = updateState;

  chips.forEach(chip => {
    chip.addEventListener('click', () => {
      if(chip.dataset.available === 'false') return;
      chips.forEach(c => c.classList.remove('active'));
      chip.classList.add('active');
      currentChip = chip;
      updateState();
    });
  });

  addBtn?.addEventListener('click', () => {
    const id = selectedVariantId();
    if(!id) return;
    setVariantQtyFast(id, 1);
    showToast('Added to cart');
  });

  card.querySelector('[data-card-plus]')?.addEventListener('click', () => {
    const id = selectedVariantId();
    if(!id) return;
    setVariantQtyFast(id, selectedQty() + 1);
  });

  card.querySelector('[data-card-minus]')?.addEventListener('click', () => {
    const id = selectedVariantId();
    if(!id) return;
    setVariantQtyFast(id, Math.max(0, selectedQty() - 1));
  });

  updateState();
}

document.querySelectorAll('[data-product-card]').forEach(initProductCard);
fetchCart().then(cart => {
  hydrateCartState(cart);
  updateCartUI(cart);
  document.querySelectorAll('[data-product-card]').forEach(card => {
    card.querySelectorAll('[data-variant-chip]').forEach(chip => {
      chip.dataset.quantity = String(cartState.variantQty.get(String(chip.dataset.variantId)) || 0);
    });
    if(typeof card._mewaramUpdateCard === 'function') card._mewaramUpdateCard();
  });
}).catch(()=>{});

/* Product detail gallery: thumbnail -> main image swap */
(function initGallery(){
  const main = document.querySelector('.gallery-main img');
  const thumbBtns = [...document.querySelectorAll('.thumbs button')];
  if(!main || !thumbBtns.length) return;
  thumbBtns[0].classList.add('active');
  function fullSrc(src){ return src ? src.replace(/(_|&)?width=\d+/,'').replace(/&height=\d+/,'') : src; }
  thumbBtns.forEach(btn => {
    const activate = () => {
      const img = btn.querySelector('img');
      if(!img) return;
      const src = img.getAttribute('src');
      main.setAttribute('src', fullSrc(src));
      if(img.alt) main.setAttribute('alt', img.alt);
      thumbBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    };
    btn.addEventListener('click', activate);
    btn.addEventListener('keydown', e => { if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); activate(); } });
  });
})();

/* Product detail quantity buttons */
document.querySelectorAll('.qty button').forEach(btn => {
  btn.addEventListener('click', () => {
    const input = btn.parentElement.querySelector('input');
    if(!input) return;
    const current = Number(input.value || 1);
    const minus = btn.hasAttribute('data-qty-minus') || btn.dataset.action === 'minus';
    input.value = minus ? Math.max(0, current - 1) : current + 1;
  });
});

/* Product detail variant price update */
const variantSelect = document.querySelector('[data-product-variant-select]');
if (variantSelect) {
  variantSelect.addEventListener('change', function(){
    const selected = this.options[this.selectedIndex];
    const price = selected.getAttribute('data-price');
    const compare = selected.getAttribute('data-compare');
    const priceEl = document.querySelector('[data-product-price]');
    const compareEl = document.querySelector('[data-product-compare]');
    const saleBadge = document.querySelector('[data-product-sale-badge]');
    if(priceEl && price) priceEl.textContent = price;
    if(compareEl){
      if(compare && compare !== price){ compareEl.textContent = compare; compareEl.style.display = ''; }
      else { compareEl.style.display = 'none'; }
    }
    if(saleBadge){ saleBadge.style.display = (compare && compare !== price) ? '' : 'none'; }
  });
}

/* Filters */
const filterPanel = document.querySelector('[data-filter-panel]');
function openFilters(){ if(filterPanel){ filterPanel.classList.add('open'); document.body.classList.add('filter-open'); } }
function closeFilters(){ if(filterPanel){ filterPanel.classList.remove('open'); document.body.classList.remove('filter-open'); } }
document.querySelectorAll('[data-filter-open]').forEach(btn => btn.addEventListener('click', openFilters));
document.querySelectorAll('[data-filter-close]').forEach(btn => btn.addEventListener('click', closeFilters));
document.addEventListener('keydown', e => { if(e.key === 'Escape') closeFilters(); });

/* Combo builder */
function initComboSection(section){
  const modal = section.querySelector('[data-combo-modal]');
  const openBtn = section.querySelector('[data-combo-open]');
  const addBtn = section.querySelector('[data-combo-add]');
  const countEl = section.querySelector('[data-combo-count]');
  const progressEl = section.querySelector('[data-combo-progress]');
  const slots = [...section.querySelectorAll('.combo-slot')];
  const products = [...section.querySelectorAll('[data-combo-product]')];
  let selected = [];

  function getVariantId(card){ return card.dataset.variantId; }
  function openModal(){ if(modal){ modal.hidden = false; document.body.style.overflow = 'hidden'; renderCombo(); } }
  function closeModal(){ if(modal){ modal.hidden = true; document.body.style.overflow = ''; } }
  function renderCombo(){
    const count = selected.length;
    if(countEl) countEl.textContent = `${count}/3 selected`;
    if(progressEl) progressEl.style.width = `${Math.min(100, (count/3)*100)}%`;
    if(addBtn) addBtn.disabled = count !== 3;
    slots.forEach((slot, index) => {
      const card = selected[index];
      if(card){
        slot.innerHTML = `<strong>${card.dataset.productTitle || `Product ${index+1}`}</strong><small>${card.dataset.weight || ''}</small>`;
        slot.classList.add('filled');
      } else { slot.textContent = String(index+1); slot.classList.remove('filled'); }
    });
    products.forEach(card => {
      const active = selected.includes(card);
      card.classList.toggle('selected', active);
      const btn = card.querySelector('[data-combo-toggle]');
      if(btn) btn.textContent = active ? 'Selected' : (count >= 3 ? 'Full' : 'Select Product');
      card.disabled = !active && count >= 3;
    });
  }

  openBtn?.addEventListener('click', openModal);
  section.querySelectorAll('[data-combo-close]').forEach(el => el.addEventListener('click', closeModal));
  products.forEach(card => {
    card.addEventListener('click', () => {
      if(card.classList.contains('disabled-preview')) return;
      if(selected.includes(card)) selected = selected.filter(item => item !== card);
      else if(selected.length < 3) selected.push(card);
      renderCombo();
    });
  });
  addBtn?.addEventListener('click', async () => {
    if(selected.length !== 3) return;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding...';
    const comboId = `combo-${Date.now()}`;
    try{
      const items = selected.map(card => ({
        id:Number(getVariantId(card)),
        quantity:1,
        properties:{'Combo Pack':'Build Your Own Combo','_combo_id':comboId}
      }));
      const res = await fetch('/cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      if(!res.ok) throw new Error('Combo add failed');
      // instant visible update, then accurate cart sync
      cartState.item_count = (cartState.item_count || 0) + 3;
      updateCartUI(cartState.item_count);
      showToast('Combo added to cart');
      closeModal();
      syncCartSoon(100);
    } catch(e){ showToast('Could not add combo'); }
    finally{ addBtn.textContent = 'Add Combo to Cart'; renderCombo(); }
  });
  if(location.hash === '#build-combo' || new URLSearchParams(location.search).get('combo') === 'open') setTimeout(openModal, 350);
  renderCombo();
}
document.querySelectorAll('[data-combo-section]').forEach(initComboSection);

/* Header elevation on scroll */
(function headerScroll(){
  const header = document.querySelector('.header');
  if(!header) return;
  const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
  onScroll();
  window.addEventListener('scroll', onScroll, {passive:true});
})();
